import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero is-fullheight p-6" }
const _hoisted_2 = { class: "container has-background-light is-flex is-flex-direction-column is-justify-content-center is-align-items-center" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "control has-icons-left" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "control has-icons-left" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "control has-text-centered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: "https://i.imgur.com/uA3fRLZ.png",
          class: "image logo-image",
          alt: "logo"
        })
      ], -1)),
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createNewPassword && _ctx.createNewPassword(...args)), ["prevent"])),
        class: "p-3"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              placeholder: _ctx.$t('UserData.PasswordPlaceholder'),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
              required: ""
            }, null, 8, _hoisted_5), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              placeholder: _ctx.$t('UserData.PassConfirmationPlaceholder'),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              required: ""
            }, null, 8, _hoisted_8), [
              [_vModelText, _ctx.confirmPassword]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-success is-fullwidth", { 'is-loading': _ctx.isProcessing }])
            }, _toDisplayString(_ctx.$t('UserData.CreateNewPassword')), 3)
          ])
        ])
      ], 32)
    ])
  ]))
}